import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/group/allocatedHours/styles.scss';export default {
  "allocatedHours": "_allocatedHours_roe0r_1",
  "edition": "_edition_roe0r_7",
  "input": "_input_roe0r_11",
  "text": "_text_roe0r_31"
};